// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/eex.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/eex.proto.
 */
export const file_bfftypes_v1_eex: GenFile = /*@__PURE__*/
  fileDesc("ChViZmZ0eXBlcy92MS9lZXgucHJvdG8SC2JmZnR5cGVzLnYxKu4BCg1FRVhQZXJpb2RUeXBlEh8KG0VFWF9QRVJJT0RfVFlQRV9VTlNQRUNJRklFRBAAEhcKE0VFWF9QRVJJT0RfVFlQRV9EQVkQARIYChRFRVhfUEVSSU9EX1RZUEVfV0VFSxACEhsKF0VFWF9QRVJJT0RfVFlQRV9XRUVLRU5EEAMSGQoVRUVYX1BFUklPRF9UWVBFX01PTlRIEAQSGwoXRUVYX1BFUklPRF9UWVBFX1FVQVJURVIQBRIaChZFRVhfUEVSSU9EX1RZUEVfU0VBU09OEAYSGAoURUVYX1BFUklPRF9UWVBFX1lFQVIQBypcCgtFRVhIb3VyVHlwZRIdChlFRVhfSE9VUl9UWVBFX1VOU1BFQ0lGSUVEEAASFgoSRUVYX0hPVVJfVFlQRV9CQVNFEAESFgoSRUVYX0hPVVJfVFlQRV9QRUFLEAJCrwEKD2NvbS5iZmZ0eXBlcy52MUIIRWV4UHJvdG9QAVpFZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO3R5cGVzogIDQlhYqgILQmZmdHlwZXMuVjHKAgtCZmZ0eXBlc1xWMeICF0JmZnR5cGVzXFYxXEdQQk1ldGFkYXRh6gIMQmZmdHlwZXM6OlYxYgZwcm90bzM");

/**
 * 受渡期間種別
 *
 * @generated from enum bfftypes.v1.EEXPeriodType
 */
export enum EEXPeriodType {
  /**
   * 未指定
   *
   * @generated from enum value: EEX_PERIOD_TYPE_UNSPECIFIED = 0;
   */
  EEX_PERIOD_TYPE_UNSPECIFIED = 0,

  /**
   * 日
   *
   * @generated from enum value: EEX_PERIOD_TYPE_DAY = 1;
   */
  EEX_PERIOD_TYPE_DAY = 1,

  /**
   * 週
   *
   * @generated from enum value: EEX_PERIOD_TYPE_WEEK = 2;
   */
  EEX_PERIOD_TYPE_WEEK = 2,

  /**
   * 週末
   *
   * @generated from enum value: EEX_PERIOD_TYPE_WEEKEND = 3;
   */
  EEX_PERIOD_TYPE_WEEKEND = 3,

  /**
   * 月
   *
   * @generated from enum value: EEX_PERIOD_TYPE_MONTH = 4;
   */
  EEX_PERIOD_TYPE_MONTH = 4,

  /**
   * 四半期
   *
   * @generated from enum value: EEX_PERIOD_TYPE_QUARTER = 5;
   */
  EEX_PERIOD_TYPE_QUARTER = 5,

  /**
   * 季節
   *
   * @generated from enum value: EEX_PERIOD_TYPE_SEASON = 6;
   */
  EEX_PERIOD_TYPE_SEASON = 6,

  /**
   * 年
   *
   * @generated from enum value: EEX_PERIOD_TYPE_YEAR = 7;
   */
  EEX_PERIOD_TYPE_YEAR = 7,
}

/**
 * Describes the enum bfftypes.v1.EEXPeriodType.
 */
export const EEXPeriodTypeSchema: GenEnum<EEXPeriodType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_eex, 0);

/**
 * 時間帯種別
 *
 * @generated from enum bfftypes.v1.EEXHourType
 */
export enum EEXHourType {
  /**
   * 未指定
   *
   * @generated from enum value: EEX_HOUR_TYPE_UNSPECIFIED = 0;
   */
  EEX_HOUR_TYPE_UNSPECIFIED = 0,

  /**
   * ベース
   *
   * @generated from enum value: EEX_HOUR_TYPE_BASE = 1;
   */
  EEX_HOUR_TYPE_BASE = 1,

  /**
   * ピーク
   *
   * @generated from enum value: EEX_HOUR_TYPE_PEAK = 2;
   */
  EEX_HOUR_TYPE_PEAK = 2,
}

/**
 * Describes the enum bfftypes.v1.EEXHourType.
 */
export const EEXHourTypeSchema: GenEnum<EEXHourType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_eex, 1);

